/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';

interface MapControlContextType {
    fitBoundsToMarkers?: () => void;
    setFitBoundsToMarkers: (fn: (() => void) | undefined) => void;
}

const MapControlContext = React.createContext<MapControlContextType | undefined>(
    undefined
);

export function MapControlProvider({ children }: { children: React.ReactNode }) {
    const [fitBoundsToMarkers, setFitBoundsToMarkers] = React.useState<
        (() => void) | undefined
    >(undefined);

    const value = React.useMemo(
        () => ({
            fitBoundsToMarkers,
            setFitBoundsToMarkers,
        }),
        [fitBoundsToMarkers]
    );

    return (
        <MapControlContext.Provider value={value}>{children}</MapControlContext.Provider>
    );
}

export function useMapControl() {
    const context = React.useContext(MapControlContext);
    if (context === undefined) {
        throw new Error('useMapControl must be used within a MapControlProvider');
    }
    return context;
}
